export enum OrganizationTypes {
  /**
   * Юр. лицо
   */
  ORGANIZATION = 'organization',

  /**
   * Физ. лицо
   */
  INDIVIDUAL = 'individual',

  /**
   * ИП
   */
  IND_ENTREPRENEUR = 'individual_entrepreneur',
}

export enum OrganizationIsCert {
  CERT = 'true',
  NOT_CERT = 'false'
}

export const OrganizationIsCertTranslate: Record<string, string> = {
  [OrganizationIsCert.CERT]: 'Сертифицирован',
  [OrganizationIsCert.NOT_CERT]: 'Не сертифицирован',
};

export const OrganizationTypesTranslate: Record<string, string> = {
  [OrganizationTypes.ORGANIZATION]: 'Юр. лицо',
  [OrganizationTypes.INDIVIDUAL]: 'Физ. лицо',
  [OrganizationTypes.IND_ENTREPRENEUR]: 'ИП',
};

export enum ActsOnBasis {
  /**
   * Устав
   */
  REGULATION = 'regulation',

  /**
   * Доверенность
   */
  ATTORNEY = 'attorney',

  /**
   * Приказ
   */
  ORDER = 'order'
}

export const ActsOnBasisTranslate: Record<string, string> = {
  [ActsOnBasis.REGULATION]: 'Устав',
  [ActsOnBasis.ATTORNEY]: 'Доверенность',
  [ActsOnBasis.ORDER]: 'Приказ',
};

/**
 * Вид договора
 */
export enum CompanyContractType {
  /**
   * С покупателем
   */
   WITH_BUYER = 'with_buyer',
}

/**
 * Ведение взаиморасчётов
 */
export enum MutualSettlements {
  /**
   * По заказам
   */
   ORDER = 'order',
}

export const CompanyContractTypeTranslate: Record<string, string> = {
  [CompanyContractType.WITH_BUYER]: 'С покупателем',
};

export const MutualSettlementsTranslate: Record<string, string> = {
  [MutualSettlements.ORDER]: 'По заказам',
};

export const organization_types = Object.keys(
  OrganizationTypesTranslate,
).map(
  (f: string) => ({ text: OrganizationTypesTranslate[f], value: f }),
);

export const basic_docs = Object.keys(
  ActsOnBasisTranslate,
).map(
  (f: string) => ({ text: ActsOnBasisTranslate[f], value: f }),
);

export enum OrganizationAgreement {
  AVAILABLE = 'true',
  NOT_AVAILABLE= 'false'
}

export const OrganizationAgreementTranslate: Record<string, string> = {
  [OrganizationAgreement.AVAILABLE]: 'Да',
  [OrganizationAgreement.NOT_AVAILABLE]: 'Нет',
};

export const organization_agreement = Object.keys(
  OrganizationAgreementTranslate,
).map(
  (f: string) => ({ text: OrganizationAgreementTranslate[f], value: f }),
);

export enum ModelIsAccreditation {
  ACCREDITATION = 'true',
  NOT_ACCREDITATION= 'false'
}

export const ModelIsAccreditationTranslate: Record<string, string> = {
  [ModelIsAccreditation.ACCREDITATION]: 'Аккредитована',
  [ModelIsAccreditation.NOT_ACCREDITATION]: 'Не аккредитована',
};

export const model_is_accreditation = Object.keys(
  ModelIsAccreditationTranslate,
).map(
  (f: string) => ({ text: ModelIsAccreditationTranslate[f], value: f }),
);

export enum PartnershipCertificateTypes {
  SALE = 'sale',
  SERVICE= 'service'
}

export enum ContractStatuses {
  ACTIVE = 'active',
  NOT_ACTIVE = 'not_active'
}

export const ContractStatusesTranslate: Record<string, string> = {
  [ContractStatuses.ACTIVE]: 'Активен',
  [ContractStatuses.NOT_ACTIVE]: 'Не активен',
};
